import { useContext, useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import {
  onlyNumberPhone,
  onlyLetter,
  emailValidation,
  removeEmojis,
  curpValidation
} from "../utils/inputsRules";
import { NotificacionContext } from "../context/notificacion_context";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import { Box } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { styled } from "@mui/material/styles";
import { services } from "../services/api";
import { useCsrfSession } from "../shared/hooks/useCsrfSession";
import LoaderComponent from "../componets/LoaderComponent";

const styleModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "1px inset #383838",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.19)",
  p: 4,
  height: "auto",
  width: {
    xs: "80%", 
    md: 500, 
  },
};


const ColorButton = styled(Button)(({ theme }) => ({
 
  color: theme.palette.getContrastText("#005cbf"),
  backgroundColor: "#4A001F",
  "&:hover": {
    backgroundColor:  "#4A001F",
  },
}));

export const CrearCuentaView = () => {
  const navigate = useNavigate();
  const { ensureReady: ensureCsrfReady } = useCsrfSession();

  const { showNotification } = useContext(NotificacionContext);

  const [boton1Habilitado, setBoton1Habilitado] = useState(true);
  const [boton2Habilitado, setBoton2Habilitado] = useState(false);

  const [loader, setLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  
  const handleClickBoton1 = () => {
  setBoton1Habilitado(false);
  setBoton2Habilitado(true);

  const newWindow = window.open(
    process.env.PUBLIC_URL + "/AVISO_DISCAPACIDAD.pdf",
    "_blank",
    "noopener,noreferrer"
  );

  if (newWindow) newWindow.opener = null;

  if (validForm()) {
    showNotification(
      "Leido",
      "Haz Leido Aviso De Discapacidad",
      null,
      null,
      10
    );
  }
};

  const handleClickBoton2 = () => {
    setBoton2Habilitado(false);
    setBoton1Habilitado(true);
  };

  const [stateError, setStateError] = useState({
    curpError: false,
    nombreError: false,
    apellidoPError: false,
    apellidoMError: false,
    fechaNacimientoError: false,
    ocupacionError: false,
    calleError: false,
    numeroError: false,
    coloniaError: false,
    municipioError: false,
    telefonoError: false,
    emailError: false,
    passError: false,
    confpassError: false,
    terminosCondicionesError: false,
  });
  const [state, setState] = useState({
    selected: "",
    selected2: "radio4",
    curp: "",
    nombre: "",
    apellidoP: "",
    apellidoM: "",
    fechaNacimiento: "",
    ocupacion: "",
    calle: "",
    numero: "",
    colonia: "",
    municipio: "",
    telefono: "",
    email: "",
    pass: "",
    confpass: "",
    sexo: "M",
    discapacidad: "",
    open: false,
    openRadio: false,
    terminosCondiciones: false,
  });

  const curpAltchaRef = useRef(null);
  const registroAltchaRef = useRef(null);
  const curpLookupInProgress = useRef(false);
  const lastCurpLookup = useRef("");
  const registrationSubmittingRef = useRef(false);
  const passwordMismatchNotificationShownRef = useRef(false);

  const [altchaReady, setAltchaReady] = useState(
    customElements.get("altcha-widget") !== undefined
  );

  const challengeUrl = process.env.NODE_ENV === "development" || !process.env.REACT_APP_URLAPI
    ? "/api/altcha-challenge"
    : `${process.env.REACT_APP_URLAPI}altcha-challenge`;

  useEffect(() => {
    if (customElements.get("altcha-widget")) {
      setAltchaReady(true);
    }
    const checkAltcha = setInterval(() => {
      if (customElements.get("altcha-widget")) {
        setAltchaReady(true);
        clearInterval(checkAltcha);
      }
    }, 100);
    return () => clearInterval(checkAltcha);
  }, []);

  useEffect(() => {
    if (window.$altcha && window.$altcha.i18n) {
      window.$altcha.i18n.set('es-419', {
        ...window.$altcha.i18n.get('es-419'),
        label: "No soy un robot",
        verified: "Verificado",
        verifying: "Verificando...",
        error: "Error al verificar",
        expired: "La verificación ha expirado. Intenta de nuevo."
      });
    }
  }, [altchaReady]);



  const openmodal = () => {
    setState({ ...state, open: true });
  };

  const openmodalRadio = () => {
    setState({ ...state, openRadio: true, selected2: "radio3" });
  };

  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const handleCloseRadio = () => {
    setState({ ...state, openRadio: false });
  };

  const validarCurpAPI = async (valorLimpio) => {
    if (curpLookupInProgress.current) return;

    curpLookupInProgress.current = true;
    setLoader(true);
    let lookupSucceeded = false;

    try {
      try {
        await ensureCsrfReady();
      } catch {
        showNotification("error", "No se pudo preparar la sesión. Intenta de nuevo.", null, null, 4);
        return;
      }
      if (!curpAltchaRef.current) {
        showNotification("error", "El captcha no está listo, por favor espera un momento", null, null, 4);
        return;
      }

      let altchaPayload;
      try {
        curpAltchaRef.current.reset();
        const result = await curpAltchaRef.current.verify();
        if (typeof result?.payload !== "string" || !result.payload.trim()) {
          throw new Error("No payload");
        }
        altchaPayload = result.payload;
      } catch (e) {
        console.error("Error executing Altcha:", e);
        showNotification("error", "Error al verificar el captcha de CURP", null, null, 4);
        return;
      }

      const bodyConCaptcha = {
        curp: valorLimpio,
        altcha: altchaPayload,
      };

      const response = await services("POST", `usuarios/renapo/${valorLimpio}`, bodyConCaptcha);

      if (response && response.status === 200) {
        lookupSucceeded = true;
        setState((prev) => ({
          ...prev,
          curp: valorLimpio,
          nombre: response.data.nombres,
          apellidoP: response.data.primerApellido,
          apellidoM: response.data.segundoApellido,
          sexo: response.data.sexo,
          fechaNacimiento: response.data.fechNac,
        }));
      } else {
        if (response && response.status === 404) {
          showNotification("error", "CURP Incorrecta o inválida", null, null, 4);
        } else {
          showNotification("error", response?.data?.mensaje || "Error interno al consumir el servicio de CURP", null, null, 4);
        }
        if (curpAltchaRef.current) curpAltchaRef.current.reset();
        setState((prev) => ({
          ...prev,
          curp: valorLimpio,
          nombre: "",
          apellidoP: "",
          apellidoM: "",
          sexo: "H",
          fechaNacimiento: "",
        }));
      }
    } catch (error) {
      console.error(error);
      showNotification("error", "Ocurrió un error al consultar la CURP", null, null, 4);
      if (curpAltchaRef.current) curpAltchaRef.current.reset();
      setState((prev) => ({
        ...prev,
        curp: valorLimpio,
        nombre: "",
        apellidoP: "",
        apellidoM: "",
        sexo: "H",
        fechaNacimiento: "",
      }));
    } finally {
      curpLookupInProgress.current = false;
      if (!lookupSucceeded) lastCurpLookup.current = "";
      setLoader(false);
    }
  };

  const handleCurp = async (e) => {
    const valorLimpio = removeEmojis(e.target.value).toUpperCase().slice(0, 18);
    if (curpLookupInProgress.current) return;
    setState((prev) => ({ ...prev, curp: valorLimpio }));
    
    if (valorLimpio.length > 17) {
      if (!curpValidation(valorLimpio)) {
        lastCurpLookup.current = "";
        showNotification("error", "Formato de CURP inválido", "Por favor revisa que tu CURP esté correcta.", null, 4);
        return;
      }

      if (lastCurpLookup.current === valorLimpio) return;
      lastCurpLookup.current = valorLimpio;
      validarCurpAPI(valorLimpio);
    } else {
      lastCurpLookup.current = "";
      setState((prev) => ({
        ...prev,
        curp: valorLimpio,
        nombre: "",
        apellidoP: "",
        apellidoM: "",
        sexo: "H",
        fechaNacimiento: "",
      }));
    }
  };

  const clearCurp = () => {
    if (curpLookupInProgress.current) return;
    lastCurpLookup.current = "";
    setState((prev) => ({
      ...prev,
      curp: "",
      nombre: "",
      apellidoP: "",
      apellidoM: "",
      sexo: "H",
      fechaNacimiento: "",
    }));
  };

  const handleNombre = (e) => {
    setState({ ...state, nombre: removeEmojis(e.target.value) });
  };

  const handleApellidoP = (e) => {
    setState({ ...state, apellidoP: removeEmojis(e.target.value) });
  };

  const handleApellidoM = (e) => {
    setState({ ...state, apellidoM: removeEmojis(e.target.value) });
  };

  const handleFechaNacimiento = (e) => {
    setState({ ...state, fechaNacimiento: e.target.value });
  };

  const handleOcupacion = (e) => {
    setState({ ...state, ocupacion: removeEmojis(e.target.value) });
  };

  const handleCalle = (e) => {
    setState({ ...state, calle: removeEmojis(e.target.value) });
  };

  const handleNumero = (e) => {
    setState({ ...state, numero: removeEmojis(e.target.value) });
  };

  const handleColonia = (e) => {
    setState({ ...state, colonia: removeEmojis(e.target.value) });
  };

  const handleMucipio = (e) => {
    setState({ ...state, municipio: removeEmojis(e.target.value) });
  };

  const handleTelefono = (e) => {
    setState({ ...state, telefono: removeEmojis(e.target.value) });
  };

  const handleEmail = (e) => {
    const value = removeEmojis(e.target.value);

    setState({
      ...state,
      email: value,
    });

    setStateError({
      ...stateError,
      emailError: value !== "" && !emailValidation(value),
    });
  };

  const handlePassword = (e) => {
    passwordMismatchNotificationShownRef.current = false;
    setState({ ...state, pass: e.target.value });
  };

  const handleConfirmPass = (e) => {
    passwordMismatchNotificationShownRef.current = false;
    setState({ ...state, confpass: e.target.value });
  };

  const handleTerminosCondiciones = (e) => {
    setState({ ...state, terminosCondiciones: e.target.value });
  };

  const passwordsDoNotMatch = state.pass !== "" && state.confpass !== "" && state.pass !== state.confpass;

  const validForm = () => {
    let curpError = state.curp === "";
    let nombreError = state.nombre === "";
    let apellidoPError = state.apellidoP === "";
    let apellidoMError = state.apellidoM === "";
    let fechaNacimientoError = state.fechaNacimiento === "";
    let ocupacionError = state.ocupacion === "";
    let calleError = state.calle === "";
    let numeroError = state.numero === "";
    let coloniaError = state.colonia === "";
    let municipioError = state.municipio === "";
    let telefonoError = state.telefono === "";
    let emailError = state.email === "" || !emailValidation(state.email);
    let passError = state.pass === "";
    let confpassError = state.confpass === "" || passwordsDoNotMatch;
    let terminosCondicionesError = state.terminosCondiciones;

    setStateError({
      curpError: curpError,
      nombreError: nombreError,
      apellidoPError: apellidoPError,
      apellidoMError: apellidoMError,
      fechaNacimientoError: fechaNacimientoError,
      ocupacionError: ocupacionError,
      calleError: calleError,
      numeroError: numeroError,
      coloniaError: coloniaError,
      municipioError: municipioError,
      telefonoError: telefonoError,
      emailError: emailError,
      passError: passError,
      confpassError: confpassError,
      terminosCondicionesError: terminosCondicionesError,
    });

    return (
      !curpError &&
      !nombreError &&
      !apellidoPError &&
      !apellidoMError &&
      !fechaNacimientoError &&
      !ocupacionError &&
      !calleError &&
      !numeroError &&
      !coloniaError &&
      !municipioError &&
      !telefonoError &&
      !emailError &&
      !passError &&
      !confpassError &&
      !terminosCondicionesError
    );
  };

  const handleCrearCuenta = () => {
    if (registrationSubmittingRef.current) return;
    if (validForm()) {
      openmodal();
    } else {
      if (state.email !== "" && !emailValidation(state.email)) {
        showNotification(
          "warning",
          "Correo Inválido",
          "Por favor, ingresa un correo electrónico válido",
          null,
          4
        );
      } else if (passwordsDoNotMatch) {
        if (!passwordMismatchNotificationShownRef.current) {
          passwordMismatchNotificationShownRef.current = true;
          showNotification(
            "warning",
            "Contraseñas diferentes",
            "La contraseña y su confirmación deben coincidir",
            null,
            4
          );
        }
      } else {
        showNotification(
          "warning",
          "Faltan Campos",
          "Favor de ingresar todos los campos",
          null,
          4
        );
      }
    }
  };

 
  const getCrearCuenta = async () => {
    if (registrationSubmittingRef.current) return;
    registrationSubmittingRef.current = true;
    setLoader(true);

    try {
      const payload = new FormData();
      payload.append("discapacidad", state.selected2 === "radio3" ? 1 : 0);
      payload.append("nombre", state.nombre);
      payload.append("apaterno", state.apellidoP);
      payload.append("amaterno", state.apellidoM);
      payload.append("email", state.email);
      payload.append("telefono", state.telefono);
      payload.append("CURP", state.curp);
      payload.append("calle", state.calle);
      payload.append("password", state.pass);
      payload.append("colonia", state.colonia);
      payload.append("municipio", state.municipio);
      payload.append("sexo", state.sexo);
      payload.append("ocupacion", state.ocupacion);
      payload.append("fechanacimiento", state.fechaNacimiento);
      payload.append("numero", state.numero);

      try {
        await ensureCsrfReady();
      } catch {
        showNotification("error", "No se pudo preparar la sesión. Intenta de nuevo.", null, null, 4);
        return;
      }
      const widget = registroAltchaRef.current;
      if (!widget || typeof widget.reset !== "function" || typeof widget.verify !== "function") {
        showNotification("error", "El captcha no está listo, por favor espera un momento", null, null, 4);
        handleClose();
        return;
      }

      try {
        widget.reset();
        const result = await widget.verify();
        if (typeof result?.payload !== "string" || !result.payload.trim()) {
          throw new Error("No payload returned from verify()");
        }
        payload.append("altcha", result.payload);
      } catch {
        showNotification("error", "Error al verificar el captcha para crear tu cuenta", null, null, 4);
        handleClose();
        return;
      }

      const dataCrearCuenta = await services(
        "POST",
        "usuarios/crearusuario",
        payload
      );

      if (dataCrearCuenta && dataCrearCuenta.status === 200) {
        if (dataCrearCuenta.data?.created === true) {
          setState({
            ...state,
            nombre: dataCrearCuenta.data.nombre,
            apellidoP: dataCrearCuenta.data.apaterno,
            apellidoM: dataCrearCuenta.data.amaterno,
            email: dataCrearCuenta.data.email,
            telefono: dataCrearCuenta.data.telefono,
            calle: dataCrearCuenta.data.calle,
            pass: dataCrearCuenta.data.password,
            colonia: dataCrearCuenta.data.colonia,
            municipio: dataCrearCuenta.data.municipio,
            sexo: dataCrearCuenta.data.sexo,
            fechaNacimiento: dataCrearCuenta.data.fechNac,
          });

          handleClose();
          showNotification("success", "¡Cuenta creada con éxito!", null, null, 4);
          navigate("/login");
        } else {
          handleClose();
          showNotification("error", dataCrearCuenta.data?.mensaje || dataCrearCuenta.data?.error || "Error al crear la cuenta", null, null, 4);
        }
      } else {
        handleClose();
        const errorMessage = dataCrearCuenta?.data?.mensaje || dataCrearCuenta?.data?.error || dataCrearCuenta?.errors || "Ocurrió un error al crear la cuenta";
        showNotification("error", errorMessage, null, null, 4);
      }
    } catch {
      handleClose();
      showNotification("error", "Ocurrió un error al crear la cuenta", null, null, 4);
    } finally {
      registrationSubmittingRef.current = false;
      setLoader(false);
    }
  };

  return (
    <>
      {loader && <LoaderComponent />}

      <div className="container mobile-container">
        <div className="cardFormulario crearCuentaForm">
          <div className="text-big text--gray">Crear Cuenta</div>

          <div >
            <Grid container spacing={2}>
            <Grid item lg={4} md={4} xs={12}>
                <TextField
                  fullWidth
                  margin="normal"
                  error={stateError.curpError}
                  id="curp"
                  label="Curp"
                  type="text"
                  variant="standard"
                  value={state.curp.toUpperCase()}
                  helperText="Ingresa tu Curp"
                  InputProps={{
                    endAdornment: state.curp && !loader ? (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="Borrar CURP"
                          onClick={clearCurp}
                          edge="end"
                          size="small"
                        >
                          <ClearIcon fontSize="small" />
                        </IconButton>
                      </InputAdornment>
                    ) : null,
                  }}
                  inputProps={{
                    style: { textTransform: "uppercase", color: "#606770" },
                    maxLength: 18
                  }}
                  disabled={loader}
                  onChange={handleCurp}
                />
                {altchaReady && (
                  <altcha-widget
                    ref={curpAltchaRef}
                    challenge={challengeUrl}
                    language="es-419"
                    hidebutton="true"
                    auto="off"
                    style={{ display: 'none' }}
                  ></altcha-widget>
                )}
              </Grid>
              <Grid item lg={4} md={4} xs={12}>
                <TextField
                  fullWidth
                  margin="normal"
                  error={stateError.nombreError}
                  id="nombre"
                  disabled
                  label="Nombre(s)"
                  type="text"
                  variant="standard"
                  value={state.nombre}
                  helperText="Ingresa tu Nombre"
                  onChange={handleNombre}
                />
              </Grid>

              <Grid item lg={4} md={4} xs={12}>
                <TextField
                  fullWidth
                  margin="normal"
                  error={stateError.apellidoPError}
                  id="apellidoP"
                  disabled
                  label="Apellido Paterno"
                  type="text"
                  variant="standard"
                  value={state.apellidoP}
                  helperText="Ingresa tu Apellido"
                  onKeyDown={(event) => {
                    onlyLetter(event, 55);
                  }}
                  onChange={handleApellidoP}
                />
              </Grid>
              <Grid item lg={4} md={4} xs={12}>
                <TextField
                  fullWidth
                  margin="normal"
                  error={stateError.apellidoMError}
                  id="apellidoM"
                  disabled
                  label="Apellido Materno"
                  type="text"
                  variant="standard"
                  value={state.apellidoM}
                  helperText="Ingresa tu Apellido"
                  onKeyDown={(event) => {
                    onlyLetter(event, 55);
                  }}
                  onChange={handleApellidoM}
                />
              </Grid>
              <Grid item lg={4} md={4} xs={12}>
                <TextField
                  fullWidth
                  margin="normal"
                  id="fechaNacimiento"
                  label="Fecha de Nacimento"
                  type="text"
                  disabled
                  variant="standard"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={state.fechaNacimiento}
                  helperText="Ingresa tu fecha de nacimiento"
                  onChange={handleFechaNacimiento}
                />
              </Grid>
              <Grid item lg={4} md={4} xs={12}>
                <TextField
                  fullWidth
                  margin="normal"
                  error={stateError.ocupacionError}
                  id="ocupacion"
                  label="Ocupación"
                  type="text"
                  variant="standard"
                  value={state.ocupacion}
                  helperText="Ingresa tu Ocupación"
                  onKeyDown={(event) => {
                    onlyLetter(event, 55);
                  }}
                  onChange={handleOcupacion}
                />
              </Grid>

              <Grid item lg={4} md={4} xs={12}>
                <TextField
                  fullWidth
                  margin="normal"
                  error={stateError.calleError}
                  id="calle"
                  label="Calle"
                  type="text"
                  variant="standard"
                  value={state.calle}
                  helperText="Ingresa tu calle"
                  onKeyPress={(event) => {
                    onlyLetter(event, 55);
                  }}
                  onChange={handleCalle}
                />
              </Grid>

              {/* Numero de casa */}
              <Grid item lg={4} md={4} xs={12}>
                <TextField
                  fullWidth
                  margin="normal"
                  error={stateError.numeroError}
                  id="numero"
                  name="houseNumber"
                  label="Número de casa"
                  type="text"
                  autoComplete="off"
                  variant="standard"
                  value={state.numero}
                  helperText="Ingresa tu número"
                  onChange={handleNumero}
                />
              </Grid>

              <Grid item lg={4} md={4} xs={12}>
                <TextField
                  fullWidth
                  margin="normal"
                  error={stateError.coloniaError}
                  id="colonia"
                  label="Colonia"
                  type="text"
                  variant="standard"
                  value={state.colonia}
                  helperText="Ingresa tu Colonia"
                  onKeyDown={(event) => {
                    onlyLetter(event, 55);
                  }}
                  onChange={handleColonia}
                />
              </Grid>

              <Grid item lg={4} md={4} xs={12}>
                <TextField
                  fullWidth
                  margin="normal"
                  error={stateError.municipioError}
                  id="municipio"
                  label="Municipio"
                  type="text"
                  variant="standard"
                  value={state.municipio}
                  helperText="Ingresa tu Municipio"
                  onKeyDown={(event) => {
                    onlyLetter(event, 55);
                  }}
                  onChange={handleMucipio}
                />
              </Grid>

              <Grid item lg={4} md={4} xs={12}>
                <TextField
                  fullWidth
                  margin="normal"
                  error={stateError.telefonoError}
                  id="telefono"
                  label="Teléfono"
                  inputProps={{ maxLength: 10 }}
                  type="text"
                  variant="standard"
                  value={state.telefono}
                  onKeyDown={onlyNumberPhone}
                  helperText="Ingresa tu Teléfono"
                  onChange={handleTelefono}
                />
              </Grid>

              <Grid item lg={4} md={4} xs={12}>
                <TextField
                  fullWidth
                  margin="normal"
                  error={stateError.emailError}
                  id="email"
                  label="Correo Electrónico"
                  type="text"
                  variant="standard"
                  helperText={stateError.emailError && state.email !== "" ? "Correo electrónico inválido" : "Ingresa tu Correo Electrónico"}
                  value={state.email}
                  autoComplete="off"
                  onChange={handleEmail}
                />
              </Grid>

              <Grid item lg={4} md={4} xs={12}>
                <TextField
                  fullWidth
                  margin="normal"
                  error={stateError.passError}
                  id="pass"
                  label="Contraseña Nueva"
                  type={showPassword ? "text" : "password"}
                  variant="standard"
                  helperText="Ingresa tu Contraseña"
                  value={state.pass}
                  autoComplete="new-password"
                  onChange={handlePassword}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                          onClick={() => setShowPassword((visible) => !visible)}
                          onMouseDown={(event) => event.preventDefault()}
                          edge="end"
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              

              <Grid item lg={4} md={4} xs={12}>
                <TextField
                  fullWidth
                  margin="normal"
                  error={(stateError.confpassError && state.confpass === "") || passwordsDoNotMatch}
                  id="confpass"
                  label="Confirma Contraseña"
                  type={showConfirmPassword ? "text" : "password"}
                  variant="standard"
                  helperText={passwordsDoNotMatch ? "Las contraseñas no coinciden" : "Confirma tu Contraseña"}
                  value={state.confpass}
                  autoComplete="new-password"
                  onChange={handleConfirmPass}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label={showConfirmPassword ? "Ocultar confirmación de contraseña" : "Mostrar confirmación de contraseña"}
                          onClick={() => setShowConfirmPassword((visible) => !visible)}
                          onMouseDown={(event) => event.preventDefault()}
                          edge="end"
                        >
                          {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={6}>
                <label>Sexo</label>
                <div className="d-flex flex-column flex-lg-row aling-content-center my-4">
                  <div className="rb1 ">
                    <input
                      id="M"
                      type="radio"
                      disabled={true}
                      onChange={() => {
                        setState({ ...state, sexo: "M" });
                      }}
                      checked={state.sexo === "M"}
                    />
                    <label htmlFor="M">Femenino</label>
                  </div>

                  <div className="rb-1">
                    <input
                      id="H"
                      type="radio"
                      disabled={true}
                      onChange={() => {
                        setState({ ...state, sexo: "H" });
                      }}
                      checked={state.sexo === "H"}
                    />{" "}
                    <label htmlFor="H">Masculino</label>
                  </div>
                </div>
              </Grid>

              <Grid justifyContent="center" item lg={4} xs={6}>
                <label>¿Cuentas con alguna Discapacidad?</label>
                <div className="d-flex flex-column flex-lg-row aling-content-center my-4">
                  <div className="rb1 ">
                    <input
                      id="radio3"
                      type="radio"
                      checked={state.selected2 === "radio3"}
                      onChange={() => {
                        openmodalRadio();
                      }}
                    />
                    <label htmlFor="radio3">Si</label>
                  </div>

                  <div className="rb-1">
                    <input
                      id="radio4"
                      type="radio"
                      checked={state.selected2 === "radio4"}
                      onChange={() => {
                        setState({ ...state, selected2: "radio4" });
                      }}
                    />{" "}
                    <label htmlFor="radio4">No</label>
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
          <div>
            <div className="mt-4 d-flex flex-column justify-content-center align-items-center">
              {altchaReady && (
                <altcha-widget
                  ref={registroAltchaRef}
                  challenge={challengeUrl}
                  language="es-419"
                  hidebutton="true"
                  auto="off"
                  style={{ display: 'none' }}
                ></altcha-widget>
              )}
              <div
                className="cta cta--guinda cta--small mt-3"
                onClick={handleCrearCuenta}
              >
                Crear Cuenta
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        open={state.openRadio}
        onClose={null}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModal}>
          <Grid
            container
            spacing={2}
            sx={{
              justifyContent: "center",
              alignItems: "center",
              marginBottom: "2%",
            }}
          >
            <Grid item>
              <InputLabel id="label-titulo" style={{ paddingBottom: "10%" }}>
                Aviso Discapacidad Importante
              </InputLabel>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={6}
            sx={{ justifyContent: "center", alignItems: "center" }}
          >
            <Grid
              item
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {boton1Habilitado && (
                <ColorButton
                  className="me-2"
                  onClick={handleClickBoton1}
                  disabled={!boton1Habilitado}
                >
                  Abrir PDF
                </ColorButton>
              )}
              {boton2Habilitado && (
                <ColorButton
                  variant="outlined"
                  type="button"
                  onClick={() => {
                    handleClickBoton2();
                    handleCloseRadio();
                  }}
                  disabled={!boton2Habilitado}
                  value={state.terminosCondiciones}
                  error={stateError.terminosCondicionesError}
                  onChange={handleTerminosCondiciones}
                >
                  Aceptar
                </ColorButton>
              )}
            </Grid>
          </Grid>
        </Box>
      </Modal>

      <Modal
        open={state.open}
        onClose={null}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModal}>
          <Grid
            container
            spacing={2}
            sx={{ justifyContent: "center", alignItems: "center" }}
          >
            <Grid item xs={9}>
              <InputLabel id="label-titulo" style={{ paddingBottom: "10%" }}>
                ¿Estás Seguro de Crear la cuenta?
              </InputLabel>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            sx={{
              justifyContent: "center",
              alignItems: "center",
              paddingTop: "4%",
            }}
          >
            <Grid item xs="auto">
              <ColorButton
                variant="outlined"
                type="button"
                disabled={loader}
                onClick={handleClose}
              >
                NO
              </ColorButton>
            </Grid>
            <Grid item xs={2}></Grid>
            <Grid item xs="auto">
              <ColorButton
                variant="outlined"
                type="button"
                disabled={loader}
                onClick={() => {
                  getCrearCuenta();
                }}
              >
                Si Quiero
              </ColorButton>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
};
